import { render, staticRenderFns } from "./PostEmpty.vue?vue&type=template&id=5b7c3771&scoped=true"
import script from "./PostEmpty.vue?vue&type=script&lang=js"
export * from "./PostEmpty.vue?vue&type=script&lang=js"
import style0 from "./PostEmpty.vue?vue&type=style&index=0&id=5b7c3771&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5b7c3771",
  null
  
)

export default component.exports